import _extends from "@babel/runtime/helpers/extends";
export const correctArrowVertical = (cornerStyle, tooltipStyle, direction, popoverRect, arrowAdaptiveBorderRadiusValue, arrowRect) => {
  var _cornerStyle$top, _cornerStyle$marginTo;
  let verticalOffset = 0;
  if (arrowRect) {
    verticalOffset += arrowRect.height / 2;
  }
  const newTooltipStyle = _extends({}, tooltipStyle);
  const newCornerStyle = _extends({}, cornerStyle);
  const top = ((_cornerStyle$top = cornerStyle == null ? void 0 : cornerStyle.top) != null ? _cornerStyle$top : popoverRect.height / 2) + ((_cornerStyle$marginTo = cornerStyle == null ? void 0 : cornerStyle.marginTop) != null ? _cornerStyle$marginTo : 0);
  if (top < arrowAdaptiveBorderRadiusValue) {
    direction === 'left' ? newTooltipStyle.borderTopRightRadius = 0 : newTooltipStyle.borderTopLeftRadius = 0;
  } else if (top > popoverRect.height - arrowAdaptiveBorderRadiusValue) {
    direction === 'left' ? newTooltipStyle.borderBottomRightRadius = 0 : newTooltipStyle.borderBottomLeftRadius = 0;
  }
  if (top < verticalOffset) {
    newCornerStyle.marginTop = 0;
    newCornerStyle.top = Math.round(verticalOffset);
  } else if (top > popoverRect.height - verticalOffset) {
    newCornerStyle.marginTop = 0;
    newCornerStyle.top = popoverRect.height - verticalOffset;
  }
  return {
    tooltipStyle: newTooltipStyle,
    cornerStyle: newCornerStyle
  };
};
export const correctArrowHorizontal = (cornerStyle, tooltipStyle, direction, popoverRect, arrowAdaptiveBorderRadiusValue, arrowRect) => {
  var _cornerStyle$left, _cornerStyle$marginLe;
  let horizontalOffset = 0;
  if (arrowRect) {
    horizontalOffset += arrowRect.width / 2;
  }
  const newTooltipStyle = _extends({}, tooltipStyle);
  const newCornerStyle = _extends({}, cornerStyle);
  const left = ((_cornerStyle$left = cornerStyle == null ? void 0 : cornerStyle.left) != null ? _cornerStyle$left : popoverRect.width / 2) + ((_cornerStyle$marginLe = cornerStyle == null ? void 0 : cornerStyle.marginLeft) != null ? _cornerStyle$marginLe : 0);
  if (left < arrowAdaptiveBorderRadiusValue) {
    direction === 'top' ? newTooltipStyle.borderBottomLeftRadius = 0 : newTooltipStyle.borderTopLeftRadius = 0;
  } else if (left > popoverRect.width - arrowAdaptiveBorderRadiusValue) {
    direction === 'top' ? newTooltipStyle.borderBottomRightRadius = 0 : newTooltipStyle.borderTopRightRadius = 0;
  }
  if (left < horizontalOffset) {
    newCornerStyle.marginLeft = 0;
    newCornerStyle.left = Math.round(horizontalOffset);
  } else if (left > popoverRect.width - horizontalOffset) {
    newCornerStyle.marginLeft = 0;
    newCornerStyle.left = popoverRect.width - horizontalOffset;
  }
  return {
    tooltipStyle: newTooltipStyle,
    cornerStyle: newCornerStyle
  };
};